import * as React from 'react';

import type { AddressFormKit } from 'v2/interfaces/addressKit';

type AddressToDeliveryKitProps = {
  address: AddressFormKit;
};

function formatZipCode(zipCode: string) {
  return zipCode
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
}

const AddressToDeliveryKit = (props: AddressToDeliveryKitProps) => {
  const { city, neighborhood, number, state, street, zipcode }: AddressFormKit = props.address;
  return (
    <p className='text-text m-0!'>{`${street}, ${number ?? 'sem número'},
    ${neighborhood}, ${city}/${state} - CEP ${formatZipCode(zipcode)}`}</p>
  );
};

export default AddressToDeliveryKit;
